import CryptoJS from "crypto-js";
import axios from "axios";
import { Pre_Loading, Show_Message } from "./Messagedialogbox";
import { jwtDecode } from "jwt-decode";
import { Update_AdminCntrl } from "../features/CommonStates";
import moment from "moment";

const Axios = axios;
// Logout_User posts through Axios, and both interceptors call Logout_User when the
// token is expired: without this guard an expired session triggered an endless
// Logout -> interceptor -> Logout loop and the storage was never cleared.
const LOGOUT_URL = "Admin/Logout_User";
let isLoggingOut = false;
const isLogoutRequest = (config) =>
  !!config && String(config.url || "").includes(LOGOUT_URL);
// Local Machine Development Domain
const DevDomain = "localhost:7295";
const ProDomain = "posserver.justbillsoftware.com";
const TestDomain = "postestserver.justbillsoftware.com";
// Live Domain
export const Domain = `https://${TestDomain}/api/`;

// Function to encrypt data
export const EncryptData = async (data) => {
  const encryptedData = await CryptoJS.AES.encrypt(
    JSON.stringify(data),
    localStorage.jbparetkau
  ).toString();
  return encryptedData;
};
// Function to decrypt data
export const DecryptData = async (data) => {
  if (data) {
    const bytes = await CryptoJS.AES.decrypt(data, localStorage.jbparetkau);
    const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    return decryptedData;
  } else return "";
};
export const Authorize = () => {
  try {
    const decoded = jwtDecode(localStorage.jbparetkau);
    const isExpired = new Date(decoded.exp * 1000) < new Date();
    if (isExpired) return false;
    return true;
  } catch (error) {
    return false;
  }
};
// axios request interceptor or Authorize requests making
Axios.interceptors.request.use(
  function (config) {
    const isAuthorize = Authorize(localStorage.jbparetkau);
    config.headers["Authorization"] = "Bearer " + localStorage.jbparetkau;
    config.baseURL = Domain;
    if (
      !isAuthorize &&
      !isLogoutRequest(config) &&
      !window.location.pathname.includes("/User-Login") &&
      !window.location.pathname.includes("/Admin/Control-Panel")
    ) {
      Logout_User();
      // FIX: a request interceptor must return the config or a rejected
      // promise - a bare `return;` sends `undefined` onward and Axios
      // throws internally before the redirect to login even happens.
      return Promise.reject(new Error("Session expired. Redirecting to login."));
    }

    return config;
  },
  // Handle Errors if Any Exception happen
  async function (e) {
    if (e.response && e.response.status === 401) {
      if (
        !window.location.pathname.includes("/User-Login") &&
        !window.location.pathname.includes("/Admin/Control-Panel")
      ) {
        Logout_User();
        return;
      }
    }
    return Promise.reject(e);
  }
);
// axios response interceptor or Authorize requests making
Axios.interceptors.response.use(
  async function (res) {
    const isAuthorize = Authorize(localStorage.jbparetkau);
    if (
      !isAuthorize &&
      !isLogoutRequest(res && res.config) &&
      !window.location.pathname.includes("/User-Login") &&
      !window.location.pathname.includes("/Admin/Control-Panel")
    ) {
      Logout_User();
      // FIX: same as the request interceptor - returning undefined here
      // means validate_response() later tries res.data on `undefined`
      // and throws instead of failing gracefully.
      return Promise.reject(new Error("Session expired. Redirecting to login."));
    }
    return res;
  },
  // Handle Errors if Any Exception happen
  async function (e) {
    if (e.response && e.response.status === 401) {
      if (
        !isLogoutRequest(e.config) &&
        !window.location.pathname.includes("/User-Login") &&
        !window.location.pathname.includes("/Admin/Control-Panel")
      )
        Logout_User();
      return;
    }
    return Promise.reject(e);
  }
);
// API GET Method
export const API_FETCH = async (parem, dispatch) => {
  try {
    const res = await Axios.get(`${parem}`).catch(async (e) => {
      await console.error(e);
      await Show_ExceptionMsg(e, dispatch);
      return;
    });
    if (res) return await validate_response(res, dispatch);
  } catch (e) {
    await Show_Message(dispatch, e.message, "error");
  }
};
// API POST Method
export const API_POST = async (url, parem, dispatch) => {
  try {
    const res = await Axios.post(`${url}`, parem).catch(async (e) => {
      await console.error(e);
      await Show_ExceptionMsg(e, dispatch);
      return;
    });
    if (res) return await validate_response(res, dispatch);
  } catch (e) {
    await Show_Message(dispatch, e.message, "error");
  }
};
// API POST Method
export const API_POSTParem = async (parem, dispatch) => {
  try {
    const res = await Axios.post(`${parem}`).catch(async (e) => {
      await console.error(e);
      await Show_ExceptionMsg(e, dispatch);
      return;
    });
    if (res) return await validate_response(res, dispatch);
  } catch (e) {
    await Show_Message(dispatch, e.message, "error");
  }
};
// API UPDATE Method
export const API_PUT = async (parem, dispatch) => {
  try {
    const res = await Axios.post(`${parem}`).catch(async (e) => {
      await console.error(e);
      await Show_ExceptionMsg(e, dispatch);
      return;
    });
    if (res) return await validate_response(res, dispatch);
  } catch (e) {
    await Show_Message(dispatch, e.message, "error");
  }
};
// API DELETE Method
export const API_DELETE = async (parem, dispatch) => {
  try {
    const res = await Axios.delete(`${parem}`).catch(async (e) => {
      await console.error(e);
      await Show_ExceptionMsg(e, dispatch);
      return;
    });
    if (res) return await validate_response(res, dispatch);
  } catch (e) {
    await Show_Message(dispatch, e.message, "error");
  }
};
// Validate API Response
// "error" / "Error" / "info" / "Validation" => message shown, undefined returned
// (the caller treats it as NOT saved). Anything else => res.data.
// FIX: res.data.strStatus.toLowerCase() threw a TypeError for responses without
// strStatus (e.g. POS/Print returns a plain number) and for an empty body.
const validate_response = async (res, dispatch) => {
  const data = res ? res.data : undefined;
  if (data === undefined || data === null || data === "") {
    await Show_Message(dispatch, "The server returned an empty response", "error");
    return;
  }
  // plain false / "Error..." / "Failed..." bodies are failures, not data
  if (data === false) {
    await Show_Message(dispatch, "The request could not be completed", "error");
    return;
  }
  if (typeof data === "string" && /^\s*(error|failed|failure|exception)\b/i.test(data)) {
    await Show_Message(dispatch, data.trim(), "error");
    return;
  }
  let status =
    typeof data === "object" && data.strStatus !== undefined && data.strStatus !== null
      ? String(data.strStatus).trim().toLowerCase()
      : "success";
  if (status === "") status = "success"; // blank status block = no verdict
  status = status === "validation" ? "info" : status;
  if (status === "failed" || status === "failure" || status === "false") status = "error";
  if (status === "error" || status === "info") {
    await Show_Message(
      dispatch,
      data.strMessage || "The request could not be completed",
      status
    );
    return;
  }
  return data;
};
// Show Exception Message
const Show_ExceptionMsg = async (res, dispatch) => {
  if (res.response) {
    if (res.response.status === 400) {
      // ASP.NET model binding: the body lists the exact field, e.g.
      // { errors: { "$.objEntALDT[0].taxAmt": ["The JSON value could not be converted to System.String..."] } }
      let strDetail = "";
      try {
        const errs = res.response.data && res.response.data.errors;
        if (errs && typeof errs === "object") {
          const strKey = Object.keys(errs)[0];
          if (strKey) {
            const arrMsg = Array.isArray(errs[strKey]) ? errs[strKey] : [errs[strKey]];
            strDetail = " (" + strKey.replace(/^\$\./, "") + ": " + String(arrMsg[0] || "").split(". Path")[0] + ")";
            console.error("API 400", res.config && res.config.url, errs);
          }
        }
      } catch (e) {
        strDetail = "";
      }
      await Show_Message(
        dispatch,
        "Please Verify the Values Data Type" + strDetail,
        "info"
      );
      return;
    } else if (res.response.status === 404) {
      await Show_Message(
        dispatch,
        "Your Requested Method is Not Found ",
        "info"
      );
      return;
    } else if (res.response.status === 405) {
      await Show_Message(
        dispatch,
        "Please Check the Request Method Type",
        "info"
      );
      return;
    } else {
      await Show_Message(dispatch, res.message, "error");
      return;
    }
  } else {
    await Show_Message(dispatch, res.message, "error");
    return;
  }
};
// Financial Year Validation
export const Validate_Financialyear = async (NxtFY, dispatch) => {
  try {
    // FIX: Using localized business date to prevent timezone discrepancy during late-night/early-morning shifts
    var currentDate = fnBusinessDate();
    const x = new Date(currentDate);
    const y = new Date(NxtFY);
    if (y < x) {
      dispatch(Update_AdminCntrl(true));
    }
  } catch (e) {
    await Show_Message(dispatch, e.message, "error");
  }
};
//Logout User When Session if Expired
export const Logout_User = async () => {
  if (isLoggingOut) return; // already on the way out (see LOGOUT_URL guard)
  isLoggingOut = true;
  try {
    const _LocalParem = await DecryptData(localStorage.jbctrlparams);
    let IPConfig = {};
    IPConfig.iUserId = Number(_LocalParem && _LocalParem.User) || 0;
    await Axios.post(LOGOUT_URL, IPConfig);
  } catch (e) {
    // server logout is best effort: an expired token / offline server must
    // never keep the cashier stuck on a dead session
    console.error(e);
  } finally {
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = "/";
  }
};
export const Backup_Data = async (dispatch, Client, Org) => {
  var link = false;
  try {
    await Pre_Loading(dispatch, true);
    await fetch(`${Domain}Admin/Backup_Data/${Client}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${localStorage.jbparetkau}`,
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.blob())
      .then((res) => {
        const url = window.URL.createObjectURL(res);
        link = document.createElement("a");
        link.href = url;
        const now = moment();
        const curr_date = now.format("D-MMM-YYYY");
        const FileName = `${Org}_${curr_date}.zip`;
        link.setAttribute("download", FileName);
        // FIX: link was created but never added to the DOM or clicked,
        // so the browser never actually triggered the file save.
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
      .catch((err) => {
        Show_Message(dispatch, err.stack, "error");
      });
  } catch (err) {
    Show_Message(dispatch, err.message, "error");
  } finally {
    await Pre_Loading(dispatch, false);
    return link;
  }
};
export const View_ScreenName = async (ScrId) => {
  switch (ScrId) {
    case 1:
      return "Product Master";
    case 2:
      return "Customer Master";
    case 3:
      return "Supplier Master";
    case 4:
      return "Category Master";
    case 5:
      return "OtherHead Master";
    case 6:
      return "Tax Master";
    case 7:
      return "Purchase Enquiry";
    case 8:
      return "Purchase Quotation";
    case 9:
      return "Purchase Order";
    case 10:
      return "Purchase Challan";
    case 11:
      return "Purchase Invoice";
    case 12:
      return "Purchase Return";
    case 13:
      return "Sales Enquiry";
    case 14:
      return "Sales Quotation";
    case 15:
      return "Sales Order";
    case 16:
      return "Sales Challan";
    case 17:
      return "Sales Invoice";
    case 18:
      return "Sales Return";
    case 29:
      return "BankAccount";
    case 32:
      return "Print Design";
    case 152:
      return "Print Line Design";
    case 37:
      return "OpenStock";
    case 38:
      return "Stock Adjustment";
    case 41:
      return "Payment";
    case 42:
      return "Receipt";
    case 43:
      return "Debit Note";
    case 44:
      return "Credit Note";
    case 50:
      return "Vendor Master";
    case 51:
      return "JobWork Master";
    case 59:
      return "Service Master";
    case 60:
      return "Attribute";
    case 61:

return "Attribute Group";
case 62:
return "Price Master";
case 63:
return "Stock Transfer";
case 64:
return "Unit Master ";
case 66:
return "Expense Income";
case 67:
return "Sales Estimate";
case 68:
return "Bill Of Material";
case 69:
return "Route Group";
case 70:
return "Production Order";
case 71:
return "Inward Challan";
case 72:
return "Outward Challan";
case 73:
return "Outward Invoice";
case 74:
return "Outsource Challan";
case 75:
return "Insource Challan";
case 76:
return "Insource Invoice";
case 77:
return "Transaction Adjustment";
case 78:
return "Purchase Estimate";
case 79:
return "JournalEntry";
case 80:
return "Price Group Master";
case 83:
return "Production Forcast";
case 86:
return "General Reports";
case 87:
return "Accounts Reports";
case 93:
return "Point of Sales";
case 96:
return "Return";
case 98:
return "Discount Master";
case 100:
return "Manual Invoice";
case 101:
return "Doctor Master";
case 102:
return "Appoinment Booking";
case 103:
return "Doctor Session";
case 104:
return "Stock Receive";
case 105:
return "Stock Trans Adjustment";
case 120:
return "Barcode Generator";
case 130:
return "Receipt Settlement";
case 131:
return "Payment Settlement";
case 151:
return "E-Way Billing";
case "0":
sessionStorage.removeItem("maxTab");
return "Configuration";
default:
sessionStorage.removeItem("maxTab");
let _AuthParems = await DecryptData(localStorage.jbctrlparams);
return _AuthParems.Branchname;
}
};

// =============================================================================
// PURE HELPERS SEGMENT  (A1 discounts / A4 IST business date / NaN safety)
// -----------------------------------------------------------------------------
// Rules for this segment - keep them when adding code here:
//   * no reference to redux, slices, dispatch, Show_Message, axios or storage:
//     input in -> value out, nothing else;
//   * `export function` declarations, NOT `export const` arrows. Function
//     declarations are hoisted and initialised when the module is linked, so the
//     redux slices (features/Transactionstates.js, features/POS.js) can call them
//     while building their initialState even if an import cycle ever forms
//     through this file (Utility -> CommonStates / Messagedialogbox -> store).
//     A `const` arrow here would throw "Cannot access 'x' before initialization".
//   * the wire date format is ALWAYS yyyy-MM-dd (HTML <input type="date"> and
//     the server / stored procedure both expect it).
// =============================================================================

// India Standard Time = UTC+05:30. India has no daylight saving.
export const BUSINESS_TZ_OFFSET_MIN = 330;

// A4: business date (yyyy-MM-dd) in IST, independent of the device timezone.
// Replaces new Date().toISOString().split("T")[0], which returned YESTERDAY
// for every bill between 00:00 and 05:30 IST.
//   fnBusinessDate()          -> today in IST
//   fnBusinessDate(dateValue) -> that instant's IST calendar date
export function fnBusinessDate(dt) {
  const IST_OFFSET_MIN = 330; // literal on purpose: no dependency on a const (see rules)
  let t = dt === undefined || dt === null ? Date.now() : new Date(dt).getTime();
  if (!Number.isFinite(t)) t = Date.now();
  return new Date(t + IST_OFFSET_MIN * 60000).toISOString().slice(0, 10);
}

// Strict API date (yyyy-MM-dd) for every date sent to POS/InsUpd_Invoice,
// POS/InsUpd_Cart and POS/InsUpd_Return. A MODIFIED bill carries dates that came
// back from View_VoucherDetails as dd-MM-yyyy / dd/MM/yyyy, and non-batch lines
// carry "" or "0000-00-00": both made STR_TO_DATE fail in the stored procedure.
//   fnApiDate("2026-10-22")                -> "2026-10-22"
//   fnApiDate("22-10-2026") / "22/10/2026" -> "2026-10-22"   (day first, India)
//   fnApiDate("2026-10-21T18:30:00Z")      -> "2026-10-22"   (instant -> IST day)
//   fnApiDate("" | null | "0000-00-00")    -> fallback (IST today by default)
export function fnApiDate(value, fallback) {
  const fb = fallback === undefined ? fnBusinessDate() : fallback;
  if (value === null || value === undefined) return fb;
  if (value instanceof Date) {
    return Number.isFinite(value.getTime()) ? fnBusinessDate(value) : fb;
  }
  const s = String(value).trim();
  if (!s) return fb;
  const pad = (n) => String(n).padStart(2, "0");
  const build = (y, m, d) => {
    const yy = Number(y);
    const mm = Number(m);
    const dd = Number(d);
    if (!(yy >= 1900 && yy <= 9999) || !(mm >= 1 && mm <= 12)) return null;
    const last = new Date(Date.UTC(yy, mm, 0)).getUTCDate();
    if (!(dd >= 1 && dd <= last)) return null;
    return `${yy}-${pad(mm)}-${pad(dd)}`;
  };
  // full ISO timestamp with a time part: it is an instant -> IST calendar day
  if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(s)) {
    const t = new Date(s).getTime();
    return Number.isFinite(t) ? fnBusinessDate(t) : fb;
  }
  let m = s.match(/^(\d{4})[-/.](\d{1,2})[-/.](\d{1,2})(?:$|[\sT])/); // yyyy-MM-dd
  if (m) return build(m[1], m[2], m[3]) || fb;
  m = s.match(/^(\d{1,2})[-/.](\d{1,2})[-/.](\d{4})(?:$|[\sT])/); // dd-MM-yyyy
  if (m) return build(m[3], m[2], m[1]) || fb;
  return fb;
}

// NaN / "" / null / undefined -> 0 (never send NaN to the API)
export function num(v) {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
}

// A1: discount fields for ProductTrans/AddUpd_Product and Delete_tableProduct.
// Always built from state.Transstates.Discount.
export function Disc_TransParems(Disc) {
  const d = Disc || {};
  return {
    dAddLessDiscValue: num(d.dALBillDisValue),
    dTBillDiscPer: num(d.dBillDisPer),
    dTBillDiscAmt: num(d.dBillDisAmt),
    dCouponDiscPer: num(d.dCouponDiscPer),
    dRewardPointper: num(d.dRewardPointper),
    dCouponDiscAmt: num(d.dCouponDiscAmt),
    dRewardPointAmt: num(d.dRewardPointAmt),
  };
}

// A1: discount fields of the invoice / return HEADER
// (POS/InsUpd_Invoice, POS/InsUpd_Cart, POS/InsUpd_Return).
export function Disc_HeaderParems(Disc) {
  const d = Disc || {};
  return {
    dTBillDiscPer: num(d.dBillDisPer),
    dTBillDiscAmt: num(d.dBillDisAmt),
    dTBillDiscValue: num(d.dBillDisValue),
    dTAddLessDiscPer: num(d.dALBillDisPer),
    dTAddLessDiscAmt: num(d.dALBillDisAmt),
    dTAddLessDiscValue: num(d.dALBillDisValue),
    dRoyaltyPoint: num(d.dRewardPointAmt),
    iCouponId: num(d.iCouponId),
  };
}

// Concurrency guard: one idempotency key per bill for POS/InsUpd_Invoice and
// POS/InsUpd_Return (sent as ?reqId=...). The server replays the stored answer
// for a key it already saved, so a double click / retry can never create a
// second invoice. Uses crypto.randomUUID when the browser has it (https or
// localhost) and a time + random fallback otherwise (plain-http LAN counters).
export function fnNewRequestId() {
  try {
    if (
      typeof crypto !== "undefined" &&
      crypto &&
      typeof crypto.randomUUID === "function"
    )
      return crypto.randomUUID();
  } catch (e) {
    // fall through to the fallback below
  }
  return (
    Date.now().toString(36) +
    "-" +
    Math.random().toString(36).slice(2, 10) +
    "-" +
    Math.random().toString(36).slice(2, 10)
  );
}

// Commercial (half away from zero) rounding to a currency unit, float-safe:
// fnMoneyRound(6092.8) -> 6093, fnMoneyRound(6092.5) -> 6093,
// fnMoneyRound(-0.5) -> -1, fnMoneyRound(12.345, 0.01) -> 12.35.
// Works in integer paise so 6092.999999 / 0.1 + 0.2 artefacts cannot shift it.
export function fnMoneyRound(value, unit) {
  const v = num(value);
  const u = num(unit) > 0 ? num(unit) : 1;
  const paise = Math.round(Math.abs(v) * 100 + 1e-6);
  const unitPaise = Math.max(1, Math.round(u * 100));
  const rounded = (Math.round(paise / unitPaise + 1e-9) * unitPaise) / 100;
  return v < 0 ? -rounded : rounded;
}